export default __webpack_public_path__ + "static/media/goto.f2c85ab8.svg";